export enum DateTimeFormatType {
    DateFormates = "DateFormates",
    DateSeperators = "DateSeperators",
    TimeFormates = "TimeFormates",
    FirstDayOfWeeks = "FirstDayOfWeeks"
}